﻿import { FC } from 'react';
import { BrightTooltip } from 'components/tooltips/BrightTooltip.tsx';
import { ProjectRoleDto } from 'services/api/api-client.types.ts';

import styles from './RoleIcon.module.scss';
import { getRoleShortName } from 'helpers/role-helper.ts';

export type RoleIconProps = {
  dto: ProjectRoleDto;
};

export const RoleIcon: FC<RoleIconProps> = (props: RoleIconProps) => {
  return (
    <BrightTooltip
      key={props.dto.id}
      title={<RoleTooltip dto={props.dto} />}
      placement="bottom"
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -8],
            },
          },
        ],
      }}
    >
      <div className={styles.icon}>{getRoleShortName(props.dto.name)}</div>
    </BrightTooltip>
  );
};

type RoleTooltipProps = {
  dto: ProjectRoleDto;
};

const RoleTooltip: FC<RoleTooltipProps> = (props) => {
  return (
    <div className={styles.tooltip}>
      <div className={styles.tooltipTitle}>{props.dto.name}</div>
      <div className={styles.tooltipItems}>
        {props.dto.signers?.map((e) => (
          <div className={styles.tooltipItem}>
            {e.signer.firstName} {e.signer.lastName}
          </div>
        ))}
      </div>
    </div>
  );
};
